import { render, staticRenderFns } from "./customDetailDialog.vue?vue&type=template&id=659f2f0f"
import script from "./customDetailDialog.vue?vue&type=script&lang=js"
export * from "./customDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports